import { images } from "./notebook-app/images";

export const articles = [
  {
    title: "Designing a Scaleable Url Shortner",
    // desc:
      // "Different portfolio templates to show your skills, experience, articles etc",
    tags: ["node", "apache-zookeeper", "distributed","scaleable"],
    // github_url: "https://github.com/MA-Ahmad/portfolio-template1",
    link:
      "https://istiak43.hashnode.dev/designing-a-scaleable-url-shortener",
    external: true,
    // isNew: true,
    // live: "https://ma-ahmad.github.io/portfolio-template1",
    published: "20 July 2023",
    readTime: "4 min read",
    // views: "721"
  },
  {
    title: "Introduction to Apache Zookeeper",
    // desc:
      // "Different portfolio templates to show your skills, experience, articles etc",
    tags: ["apache-zookeeper"],
    // github_url: "https://github.com/MA-Ahmad/portfolio-template1",
    link:
      "https://istiak43.hashnode.dev/introduction-to-apache-zookeeper",
    external: true,
    // isNew: true,
    // live: "https://ma-ahmad.github.io/portfolio-template1",
    published: "16 June 2023",
    readTime: "4 min read",
    // views: "721"
  },
  {
    title: "Building a simple code Runner with typescript , docker , react and express",
    // desc:
      // "Different portfolio templates to show your skills, experience, articles etc",
    tags: ["node", "react", "docker"],
    // github_url: "https://github.com/MA-Ahmad/portfolio-template1",
    link:
      "https://istiak43.hashnode.dev/building-a-simple-code-runner-with-typescript-docker-react-and-express",
    external: true,
    // isNew: true,
    // live: "https://ma-ahmad.github.io/portfolio-template1",
    published: "23 May 2023",
    readTime: "7 min read",
    // views: "721"
  },
  {
    title: "How to use different environment variables for development and production in Node.js",
    // desc:
      // "Different portfolio templates to show your skills, experience, articles etc",
    tags: ["node", "react", "env"],
    // github_url: "https://github.com/MA-Ahmad/portfolio-template1",
    link:
      "https://dev.to/istiak/how-to-use-different-environment-variables-for-development-and-production-in-nodejs-2dlh",
    external: true,
    // isNew: true,
    // live: "https://ma-ahmad.github.io/portfolio-template1",
    published: "28 February 2023",
    readTime: "1 min read",
    // views: "721"
  },
  {
    title: "Remotely controlled SpyCam with nodejs and telegram",
    // desc:
      // "Different portfolio templates to show your skills, experience, articles etc",
    tags: ["node", "telegram", "automation"],
    // github_url: "https://github.com/MA-Ahmad/portfolio-template1",
    link:
      "https://dev.to/istiak/remotely-controlled-spycam-with-nodejs-and-telegram-564o",
    external: true,
    // isNew: true,
    // live: "https://ma-ahmad.github.io/portfolio-template1",
    published: "04 June 2022",
    readTime: "5 min read",
    // views: "721"
  },
  {
    title: "Building a simple Rick and morty character app with Graphql and Nextjs",
    // desc:
      // "Different portfolio templates to show your skills, experience, articles etc",
    tags: ["node", "next.js", "graphql","Rick & Morty"],
    // github_url: "https://github.com/MA-Ahmad/portfolio-template1",
    link:
      "https://dev.to/istiak/building-a-simple-rick-and-morty-character-app-with-graphql-and-nextjs-5hf1",
    external: true,
    // isNew: true,
    // live: "https://ma-ahmad.github.io/portfolio-template1",
    published: "10 September 2021",
    readTime: "5 min read",
    // views: "721"
  },
];
